import React from 'react';
import "./styles.scss";

interface IContainerProps {

}

const Container: React.FC<IContainerProps> = ({children}) => {
  return (
    <div className="container">
      {children}
    </div>
  );
};

export default Container;
